<script setup lang="ts">
import { IconCheckmark } from "@iconify-prerendered/vue-carbon";

// Props
type Props = {
  helpText?: string;
  label?: string;
  name: string;
  placeholder?: string;
  disabled?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  helpText: "",
  type: "text",
  label: "",
  placeholder: "",
  disabled: false
});

const model = defineModel<boolean>();

</script>

<template>
  <div
    v-bind="props"
    class="flex gap-3 align-center items-center select-none"
    @click="model = !model"
  >
    <div>
      <div class="checkbox-box">
        <IconCheckmark class="checkbox-box-mark" v-if="model" />
      </div>
    </div>
    <span>
      <slot />
    </span>
  </div>
</template>

<style scoped lang="scss">
.checkbox-box {
  display: block;
  background-color: var(--m-light);
  border: 1px solid var(--m-neutral-700);
  width: 24px;
  height: 24px;
  border-radius: 0.25rem;
}

.checkbox-box:hover {
  border: 1px solid var(--m-primary-base);
}

.checkbox-box-mark {
  color: var(--m-primary-base);
  width: 100%;
  height: 100%;
}
</style>
